import React, { FunctionComponent } from 'react';
import styles from './page-section.module.scss';
import classNames from 'classnames/bind';
import Section from '../section/section';
import { checkIfVideo } from '../../utils/utils';
import { IElevatoListItem } from '../../templates/page';

export interface IPageSectionProps {
  containItems: IKontentItem[];
  sectionId: string;
  additionamMarginInColumn: string;
  additionamMarginInRow: string;
  aligmentInColumn: string;
  aligmentInRow: string;
  backgroundColor: string;
  backgroundAsset: string;
  predefinedContainer: boolean;
  withBorder: boolean;
  dotsInBackground: boolean;
  removeMargin: string;
  jobOffersElevato: IElevatoListItem[];
}

const cx = classNames.bind(styles);

export const PageSection: FunctionComponent<IPageSectionProps> = props => {
  const {
    containItems,
    sectionId,
    additionamMarginInColumn,
    additionamMarginInRow,
    aligmentInColumn,
    aligmentInRow,
    backgroundColor,
    backgroundAsset,
    predefinedContainer,
    withBorder,
    dotsInBackground,
    removeMargin,
    jobOffersElevato
  } = props;
  const assetExtension = backgroundAsset.replace(/^.*\./, '');

  const sectionClass = cx({
    section: true,
    alignRowDefault: !predefinedContainer && aligmentInRow === 'default',
    alignLeft: !predefinedContainer && aligmentInRow === 'left',
    alignRowCenter: !predefinedContainer && aligmentInRow === 'center',
    alignRight: !predefinedContainer && aligmentInRow === 'right',
    alignColumnDefault: !predefinedContainer && aligmentInRow === 'default',
    alignTop: aligmentInColumn === 'top',
    alignColumnCenter: aligmentInColumn === 'center',
    alignBottom: aligmentInColumn === 'down',
    backgroundColorPrimary: backgroundColor === 'primary',
    backgroundColorWhite: backgroundColor === 'white',
    backgroundColorSecondary: backgroundColor === 'secondary',
    backgroundColorLightGray: backgroundColor === 'light_gray',
    backgroundColorTransparent: backgroundColor === 'transparent',
    dotsInBackground: dotsInBackground
  });

  const containerClass = cx({
    container: true,
    predefined: predefinedContainer,
    alignRowDefault: aligmentInRow === 'default',
    alignLeft: aligmentInRow === 'left',
    alignRowCenter: aligmentInRow === 'center',
    alignRight: aligmentInRow === 'right',
    marginSmallColumn: additionamMarginInColumn === 'small',
    marginMediumColumn: additionamMarginInColumn === 'medium',
    marginLargeColumn: additionamMarginInColumn === 'large',
    marginExtraLargeColumn: additionamMarginInColumn === 'extra_large',
    marginSmallRow: !predefinedContainer && additionamMarginInRow === 'small',
    marginMediumRow: !predefinedContainer && additionamMarginInRow === 'medium',
    marginLargeRow: !predefinedContainer && additionamMarginInRow === 'large',
    marginExtraLargeRow:
      !predefinedContainer && additionamMarginInRow === 'extra_large',
    withBorder: withBorder,
    removeMarginTop: removeMargin === 'top',
    removeMarginBottom: removeMargin === 'bottom',
    videoBackground: checkIfVideo(assetExtension)
  });

  const containerStyle = {
    backgroundImage: backgroundAsset ? `url(${backgroundAsset})` : '',
    overflow: sectionId === 'unsetoverflow' ? 'unset' : ''
  };

  return (
    <section id={sectionId} className={sectionClass} style={containerStyle}>
      {checkIfVideo(assetExtension) && (
        <video
          className={styles.video}
          autoPlay
          loop
          muted
          src={backgroundAsset}
        ></video>
      )}
      <div className={containerClass}>
        {containItems.map((item, i) => (
          <Section
            linkedItem={item}
            key={i}
            jobOffersElevato={jobOffersElevato}
          />
        ))}
      </div>
    </section>
  );
};
